import apiClient from './client';

export interface DatabaseStatus {
  host: string;
  port: string;
  database: string;
  sizeInMB: number;
  tableCount: number;
  tables: Array<{ table_name: string; table_rows: number }>;
  lastBackup: string | null;
}

export const getDatabaseStatus = async (): Promise<DatabaseStatus> => {
  const response = await apiClient.get('/database/status');
  return response.data.data;
};

export const optimizeDatabase = async (): Promise<void> => {
  await apiClient.post('/database/optimize');
};

export const clearCache = async (): Promise<void> => {
  await apiClient.post('/database/clear-cache');
};

export const createBackup = async (): Promise<{ filename: string; sizeBytes: number; createdAt: string }> => {
  const response = await apiClient.post('/database/backup');
  return response.data;
};

export const downloadLatestBackup = async (): Promise<void> => {
  const response = await apiClient.get('/database/backup/download', { responseType: 'blob' });
  const disposition = response.headers['content-disposition'] || '';
  const nameMatch = disposition.match(/filename="?([^"]+)"?/);
  const filename = nameMatch?.[1] ?? `backup-${Date.now()}.sql`;
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
